import aesReduxConstants from '../constants';
import auditLogApi from '../apis/auditLogApi';

const auditLogActions = function() {
  const self = {};
  const constants = aesReduxConstants.AUDIT_LOG;

  self.initForm = function(initialForm) {
    return function(dispatch) {
      dispatch(self.getSubjects());
      dispatch(self.getActions());
    };
  };

  self.querySuccess = function(response) {
    const list = response.data;

    return {
      type: constants.GET_LIST_SUCCESS,
      list,
    };
  };

  self.queryError = function(error) {
    return {
      type: constants.GET_LIST_ERROR,
      error,
    };
  };

  self.query = function(form) {
    return function(dispatch) {
      dispatch({ type: constants.GET_LIST });
      auditLogApi.query(form)
        .then((response) => {
          dispatch(self.querySuccess(response));
        }, (error) => {
          dispatch(self.queryError(error));
        });
    };
  };

  self.getDetailsSuccess = function(response) {
    const current = response.data;

    return {
      type: constants.GET_DETAILS_SUCCESS,
      current,
    };
  };

  self.getDetailsError = function(error) {
    return {
      type: constants.GET_DETAILS_ERROR,
      error,
    };
  };

  self.getDetails = function(clientId, id) {
    return function(dispatch) {
      dispatch({ type: constants.GET_DETAILS });
      auditLogApi.getById(clientId, id)
        .then((response) => {
          dispatch(self.getDetailsSuccess(response));
        }, (error) => {
          dispatch(self.getDetailsError(error));
        });
    };
  };

  self.getRelatedSuccess = function(response) {
    const related = response.data;

    return {
      type: constants.GET_RELATED_SUCCESS,
      related,
    };
  };

  self.getRelatedError = function(error) {
    return {
      type: constants.GET_RELATED_ERROR,
      error,
    };
  };

  self.getRelated = function(clientId, id, limit) {
    return function(dispatch) {
      dispatch({ type: constants.GET_RELATED });
      auditLogApi.getRelated(clientId, id, limit)
        .then((response) => {
          dispatch(self.getRelatedSuccess(response));
        }, (error) => {
          dispatch(self.getRelatedError(error));
        });
    };
  };


  self.getSubjectsSuccess = function(response) {
    const subjects = response.data;

    return {
      type: constants.GET_SUBJECTS_SUCCESS,
      subjects,
    };
  };

  self.getSubjectsError = function(error) {
    return {
      type: constants.GET_SUBJECTS_ERROR,
      error,
    };
  };

  self.getSubjects = function() {
    return function(dispatch) {
      dispatch({ type: constants.GET_SUBJECTS });
      auditLogApi.getSubjects()
        .then((response) => {
          dispatch(self.getSubjectsSuccess(response));
        }, (error) => {
          dispatch(self.getSubjectsError(error));
        });
    };
  };

  self.getActionsSuccess = function(response) {
    const actions = response.data;

    return {
      type: constants.GET_ACTIONS_SUCCESS,
      actions,
    };
  };

  self.getActionsError = function(error) {
    return {
      type: constants.GET_ACTIONS_ERROR,
      error,
    };
  };

  self.getActions = function() {
    return function(dispatch) {
      dispatch({ type: constants.GET_ACTIONS });
      auditLogApi.getActions()
        .then((response) => {
          dispatch(self.getActionsSuccess(response));
        }, (error) => {
          dispatch(self.getActionsError(error));
        });
    };
  };

  self.getClientsSuccess = function(response) {
    const clients = response.data;

    return {
      type: constants.GET_CLIENTS_SUCCESS,
      clients,
    };
  };

  self.getClientsError = function(error) {
    return {
      type: constants.GET_CLIENTS_ERROR,
      error,
    };
  };

  self.getClients = function() {
    return function(dispatch) {
      dispatch({ type: constants.GET_CLIENTS });
      auditLogApi.getClients()
        .then((response) => {
          dispatch(self.getClientsSuccess(response));
        }, (error) => {
          dispatch(self.getClientisError(error));
        });
    };
  };

  self.getUsersSuccess = function(response) {
    const users = response.data;

    return {
      type: constants.GET_USERS_SUCCESS,
      users,
    };
  };

  self.getUsersError = function(error) {
    return {
      type: constants.GET_USERS_ERROR,
      error,
    };
  };

  self.getUsers = function(clientId) {
    return function(dispatch) {
      dispatch({ type: constants.GET_USERS });
      auditLogApi.getUsers(clientId)
        .then((response) => {
          dispatch(self.getUsersSuccess(response));
        }, (error) => {
          dispatch(self.getUsersError(error));
        });
    };
  };

  return self;
};

export default auditLogActions();
